import type { IconData } from '@stacksjs/iconify-core'

export const layoutRightSidebar: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M8.458 41.759c-2.891-.107-5.15-2.349-5.258-5.24C3.095 33.714 3 29.624 3 24s.095-9.714.2-12.52c.109-2.89 2.367-5.132 5.258-5.239C11.758 6.12 16.82 6 24 6s12.242.12 15.542.241c2.891.107 5.15 2.349 5.258 5.24c.105 2.805.2 6.895.2 12.519s-.095 9.714-.2 12.52c-.109 2.89-2.367 5.132-5.258 5.239C36.242 41.88 31.18 42 24 42s-12.242-.12-15.542-.241M30 6.031v35.94M36 13h3m-3 6h3m-3 6h3\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default layoutRightSidebar
